module.exports = __webpack_public_path__ + "img/sell_puzzle.54a4602a.svg";